import { Pill } from "@sveabank/cc-common";
import { useApplicationDetails } from "../../../hooks/application";
import { usePageContext } from "../../../hooks/context";
import type { OnboardingPackage } from "../../../types/package";
import { stepIs } from "../../../utils/application";
import { useChoosePackage } from "../hooks";

type Props = { onboardingPackage: OnboardingPackage };

export const InterestDiscountTags = ({ onboardingPackage }: Props) => {
	const { steps } = usePageContext(useChoosePackage);
	const { applicationDetails } = useApplicationDetails();

	const interestPromotion = applicationDetails?.promotions.find(
		(p) => p.promotionType === "interestRateDiscount",
	);
	const creditScore = steps.find(stepIs("CreditScoreStep"))?.state;

	if (!interestPromotion || !creditScore || !creditScore.assessment) return;

	const hasCheckCredit = onboardingPackage.products.find((p) => p.definitionId === "CHECKKREDIT");
	const hasCreditCard = onboardingPackage.products.find((p) => p.definitionId === "CREDITCARD");

	const tags = [];

	if (hasCheckCredit)
		tags.push(
			<Pill
				status="info"
				text={`Kontokredit – din kampanjränta ${creditScore.assessment.check.interestRate} %`}
			/>,
		);

	if (hasCreditCard) {
		// TODO: Remove this ugly fucking hack.
		if (onboardingPackage.packageId === "FORETAGARNA-CARDONLY") {
			tags.push(<Pill status="info" text={`Kreditkort – din kampanjränta 11.8 %`} />);
		} else {
			tags.push(
				<Pill
					status="info"
					text={`Kreditkort – din kampanjränta ${creditScore.assessment.card.interestRate} %`}
				/>,
			);
		}
	}

	return <div className="flex flex-col gap-2">{tags}</div>;
};
